import Client from '../axiosClient'
const resource = '/booking_payment_data';
const resourceInit = '/booking_payment_data';
export default {
  init() {
    return Client.get(`${resourceInit}`);
  },

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },

  get(payload) {
    if(payload) {
      return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}`);
    }
    return Client.get(`${resource}`);
  },

};



// WEBPACK FOOTER //
// ./src/repositories/events/paymentDetailsRepository.js